import { setData } from './data';
import { Thunk } from '../types';

export function setCurrentNetworkId(networkId: string): Thunk {
  return dispatch => {
    dispatch(setData({ currentNetworkId: networkId }, 'navigation/SET_NETWORK_ID'));
  };
}
